import { JailRecordStatus } from "./jail.types"
import type { IJailStatusData, IJailRecord, IJailTimeInfo } from "./jail.types"

export const isUserInJail = (
  jailData: IJailStatusData | null | undefined
): boolean => {
  return jailData?.isInJail === true
}

export const isJailSentenceExpired = (
  timeInfo: IJailTimeInfo | null | undefined
): boolean => {
  if (!timeInfo) return true

  return timeInfo.isExpired || timeInfo.remainingMs <= 0
}

export const getCurrentJailRecord = (
  jailData: IJailStatusData | null | undefined
): IJailRecord | null => {
  return jailData?.jail || null
}

export const getJailHistory = (
  jailData: IJailStatusData | null | undefined
): IJailRecord[] => {
  return jailData?.jailHistory || []
}

export const getLatestJailCase = (
  jailData: IJailStatusData | null | undefined
): IJailRecord | null => {
  if (!jailData) return null

  if (isUserInJail(jailData) && jailData.jail) {
    return jailData.jail
  }

  const history = getJailHistory(jailData)
  return history.length > 0 ? history[0] : null
}

export const canStartCorrectionalWork = (
  jailData: IJailStatusData | null | undefined
): boolean => {
  const workInfo = jailData?.correctionalWorkInfo
  return workInfo?.canStartNew === true && workInfo?.isInProgress !== true
}

export const isCorrectionalWorkInProgress = (
  jailData: IJailStatusData | null | undefined
): boolean => {
  return jailData?.correctionalWorkInfo?.isInProgress === true
}

export const getBuyoutCost = (
  jailData: IJailStatusData | null | undefined
): number => {
  return jailData?.jail?.buyoutAmountGold || 0
}

export const canAffordBuyout = (
  jailData: IJailStatusData | null | undefined,
  userGold: number
): boolean => {
  const cost = getBuyoutCost(jailData)
  return userGold >= cost && cost > 0
}

export const formatJailReasons = (jailRecord: IJailRecord | null): string => {
  if (!jailRecord?.reasons || jailRecord.reasons.length === 0) {
    return "No specific reasons provided"
  }

  return jailRecord.reasons
    .map((reason) => reason.label || reason.id)
    .join(", ")
}

export const isJailRecordActive = (record: IJailRecord | null): boolean => {
  return record?.status === JailRecordStatus.ACTIVE
}

export const formatJailTimeRemaining = (
  timeInfo: IJailTimeInfo | null | undefined
): string => {
  if (!timeInfo || timeInfo.isExpired) return "00:00:00"

  const hours = Math.floor(timeInfo.remainingMs / (1000 * 60 * 60))
  const minutes = Math.floor(
    (timeInfo.remainingMs % (1000 * 60 * 60)) / (1000 * 60)
  )
  const seconds = Math.floor((timeInfo.remainingMs % (1000 * 60)) / 1000)

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}
